import React, {useState} from 'react';
import {Col, Container, Row, Collapse} from 'reactstrap';

import image1 from "../../assets/images/demos/1.svg";
import image2 from "../../assets/images/demos/2.svg";
import image3 from "../../assets/images/demos/3.svg";
import image4 from "../../assets/images/demos/4.svg";
import image5 from "../../assets/images/demos/5.svg";
import image6 from "../../assets/images/demos/6.svg";
import image7 from "../../assets/images/demos/7.svg";
import image8 from "../../assets/images/demos/8.svg";
import image9 from "../../assets/images/demos/9.svg";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../config';

const Faqs = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <h1 className='mb-5 fw-bold'>
                        {t('t-why-app-head').replace('{appName}', appConfig.appName)} ?
                    </h1>
                    <Row style={{rowGap: "20px"}}>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image1} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>{t('t-why-app1')}</h4>
                                    <p className='fw-light'>{t('t-why-app1-desc').replace('{appName}', appConfig.appName)}</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image2} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>{t('t-why-app2')}</h4>
                                    <p className='fw-light'>
                                        {t('t-why-app2-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image3} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>
                                        {t('t-why-app3')}
                                    </h4>
                                    <p className='fw-light'>
                                        {t('t-why-app3-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image4} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>
                                        {t('t-why-app4')}
                                    </h4>
                                    <p className='fw-light'>
                                        {t('t-why-app4-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image5} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>
                                        {t('t-why-app5')}
                                    </h4>
                                    <p className='fw-light'>
                                        {t('t-why-app5-desc').replace('{appName}', appConfig.appName)}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image6} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>
                                        {t('t-why-app6')}
                                    </h4>
                                    <p className='fw-light'>
                                        {t('t-why-app6-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image7} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>
                                        {t('t-why-app7')}
                                    </h4>
                                    <p className='fw-light'>
                                        {t('t-why-app7-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image8} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>
                                        {t('t-why-app8')}
                                    </h4>
                                    <p className='fw-light'>
                                        {t('t-why-app8-desc')}
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='d-flex gap-3'>
                                <div>
                                    <img src={image9} alt=''></img>
                                </div>
                                <div>
                                    <h4 className='fw-bold fs-17'>
                                        {t('t-why-app9')}
                                    </h4>
                                    <p className='fw-light'>
                                        {t('t-why-app9-desc').replace('{appName}', appConfig.appName)}
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Faqs;